import React from 'react';

import { FaArrowTrendUp } from 'react-icons/fa6';
import { FcSalesPerformance } from 'react-icons/fc';
import { PiStrategyBold } from 'react-icons/pi';

const ICONS = {
  Performance: <FcSalesPerformance size={15} />,
  "Strategic Planning": <PiStrategyBold size={15} />,
  Trend: <FaArrowTrendUp size={15} />,
};

const CategoryQues = ({ data, handleClick }) => {
  return (
    <div className="flex flex-col items-center w-1/3">
      <div>{ICONS[data.title]}</div>
      <div className="text-white text-md">{data.title}</div>
      <div className="flex flex-col gap-3 p-1">
        {data.questions.map((ques, index) => {
          return (
            <button
              key={index}
              onClick={() => handleClick(ques)}
              className="text-xs rounded-lg p-2 bg-zinc-800 text-zinc-200 min-h-[80px]"
            >
              {ques}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CategoryQues;
